import { render } from "./FollowFestival.vue?vue&type=template&id=b5f0e0ee&ts=true"
import script from "./FollowFestival.vue?vue&type=script&lang=ts"
export * from "./FollowFestival.vue?vue&type=script&lang=ts"

import "./FollowFestival.vue?vue&type=style&index=0&id=b5f0e0ee&lang=css"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__